import z from "zod";

export const CreateProjectSchema = z.object({
    name: z.string().min(1, "Project name is required"),
    location: z.string().min(1, "Project location is required"),
    description: z.string(),
    start_date: z.string().min(1, "Start date is required"),
    end_date: z.string().nullable().optional(),
    client_id: z.string().min(1, "Client  is required"),
    client_representative: z.object({
        id: z.string(),
        first_name: z.string().optional(),
        last_name: z.string().optional(),
        full_name: z.string().min(1, "Full name is required"),
        email: z.string().email().or(z.literal("")),
        phone_number: z.string(),
    }),
    client_location: z.string().min(1, "Client location is required"),
    client_vendor_code: z.string().min(1, "Vendor code is required"),
    client_rate: z.number({
        required_error: "Client rate is required",
        invalid_type_error: "Client rate must be a valid number",
    }),
    client_commission: z.number({
        required_error: "Client commission is required",
        invalid_type_error: "Client commission must be a valid number",
    }),
    reference_number: z.string(),
    ar_coordinator_id: z.string().min(1, "AR coordinator is required"),
    deduction: z.boolean(),
    po_number: z.string(),
    deduction_amount: z.number(),
    closed: z.boolean().optional(),
});

export type CreateProjectSchema = z.infer<typeof CreateProjectSchema>;
